import { BasicLazyParams } from '../../../../../utile';

export const SEARCH_TYPE_OPTIONS = [
    { label: 'Student Name', value: 'studentName' },
    { label: 'Enrollment Number', value: 'enrollmentNumber' }
];

export const INITIAL_STATE = {
    isAddEnabled: false,
    isLoading: false,
    users: [],
    filterData: null,
    columns: [{ columnName: 'Created At', isVisible: false, id: 'createDateTime' }],
    isUserNameSearch: false,
    isUserEnrollSearch: false,
    isRaiseDialogOpen: false,
    username: '',
    boardId: null,
    classId: null,
    groupId: null,
    sectionIds: [],
    boards: [],
    classes: [],
    groups: [],
    sections: [],
    branchLevels: {},
    onShowNewFeeInfo: false,
    onShowOldFeeInfo: false,
    selectedAdmission: '',
    searchLevel: 1,
    searchType: SEARCH_TYPE_OPTIONS[0].value,
    searchValue: '',
    lazyParams: BasicLazyParams,
    selectedUser: [],
    globalSearch: '',
    totalRecords: 0,
    isTransferDialogOpen: false,
    transferFee: '',
    selectAll: false,
    select: false,
    isShowAlternativeSchedules: false,
    selectedTransferStudents: [],
    dropdownsDataDilogData: {},
    rowData: {},
    selectedRows: {},
    transfer: null,
    flag: false,
    dropdownsData: {},
    branchId: null,
    admissionCategories: [],
    branchName: null,
    totalFee: 0,
    remarks: '',
    selectedStudentData: {},
    admissionChangeCheckResponse: null,
    message: '',
    showResponseDialog: false,
    relatedFeeSchedules: [],
    selectedFeeSchedule: null,
    feeStructureInfo: [],
    originalNewFeeResponse: null,
    isFromFeeScheduleSelection: false,
    isShowInstallmentInfo: false,
    effectiveDate: '',
    oldFeeInfo: null,
    newFeeResponse: null,
    manualAdjustmentFeeInfo: null,
    totalClosingDueAmt: 0,
    totalClosingAdvance: 0,
    adjustmentRuleNo: null,
    selectedFeePlan: null,
    installmentData: [],
    oneTimeFees: [],
    selectedFeeStructure: [],
    plansData: []
};

export const TOAST_TYPES = {
    SUCCESS: 'success',
    ERROR: 'error',
    WARN: 'warn',
    INFO: 'info'
};

export const ADJUSTMENT_RULES = {
    MANUAL_ADJUSTMENT: 6
};
